var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: _vm.sectionClass }, [
    _c("div", { staticClass: "section-content" }, [
      _c("div", { staticClass: "columns column-text-side break-1024" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "title is-spaced" }, [
            _vm._v(_vm._s(_vm.$t("home.section_who.title"))),
          ]),
          _c("p", { staticClass: "subtitle subtitle-right-padding" }, [
            _vm._v(_vm._s(_vm.$t("home.section_who.content1") + " ")),
            _c("br"),
            _vm._v(_vm._s(_vm.$t("home.section_who.content2"))),
          ]),
        ]),
        _vm._m(0),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("img", {
        staticClass: "who",
        attrs: { src: "/img/pics.jpg", alt: "", draggable: "false" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }